import { createFileRoute } from '@tanstack/react-router';

import { NotFoundPage } from '@apple/ui/shell/pages/NotFoundPage';

export const Route = createFileRoute('/(errors)/not-found')({
	component: NotFoundPage,
});
